/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S3_P3Inputs */

const en_guide_what_is_json_s3_p3 = /** @type {(inputs: Guide_What_Is_Json_S3_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today, JSON is used everywhere: REST APIs, configuration files (like <code>package.json</code> and <code>tsconfig.json</code>), NoSQL databases (MongoDB, CouchDB), and even communication protocols like JSON-RPC.`)
};

const ko_guide_what_is_json_s3_p3 = /** @type {(inputs: Guide_What_Is_Json_S3_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘날 JSON은 어디에서나 사용됩니다: REST API, 설정 파일(<code>package.json</code>이나 <code>tsconfig.json</code> 등), NoSQL 데이터베이스(MongoDB, CouchDB), 그리고 JSON-RPC 같은 통신 프로토콜에서도 사용됩니다.`)
};

const ja_guide_what_is_json_s3_p3 = /** @type {(inputs: Guide_What_Is_Json_S3_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在、JSONはあらゆる場面で使用されています：REST API、設定ファイル（<code>package.json</code>や<code>tsconfig.json</code>など）、NoSQLデータベース（MongoDB、CouchDB）、さらにはJSON-RPCのような通信プロトコルでも利用されています。`)
};

/**
* | output |
* | --- |
* | "Today, JSON is used everywhere: REST APIs, configuration files (like <code>package.json</code> and <code>tsconfig.json</code>), NoSQL databases (MongoDB, Cou..." |
*
* @param {Guide_What_Is_Json_S3_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s3_p3 = /** @type {((inputs?: Guide_What_Is_Json_S3_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S3_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s3_p3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s3_p3(inputs)
	return ja_guide_what_is_json_s3_p3(inputs)
});